<template>
  <div>
    <div class="pos-fnb-final-ticket-wrapper vh-100">
      <button class="btn-modal-close" @click="callClose()">&times;</button>
      <div class="h4 font-weight-bold text-center mt-5">
        Add Money To E-Wallet
      </div>
      <div class="my-5 d-flex align-items-center">
        <div class="col-10 mx-auto">
          <div class="row">
            <div class="col-12 align-self-center">
              <div class="w-100 fnb-movie-ticket">
                <div class="row mx-0">
                  <div class="col-6 fnb-mt-cut py-2">
                    <div class="col-12 px-0">
                      <div class="row">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Customer</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold">
                            {{ topUpWalletDetails.cust_name }}
                          </h6>
                        </div>
                      </div>
                      <div class="row border-bottom mb-2">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Mobile Number</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold">
                            {{ topUpWalletDetails.cust_mobile || "-" }}
                          </h6>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Balance</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold">
                            {{ Currency | uppercase }}&nbsp;{{
                              currFormat(topUpWalletDetails.wallet_balance)
                            }}
                          </h6>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Amount Added</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold text-success">
                            {{'+'}}{{ Currency | uppercase }}&nbsp;{{
                              currFormat(topUpWalletDetails.add_amount)
                            }}
                          </h6>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Current Balance</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold">
                            {{ Currency | uppercase }}&nbsp;{{
                              currFormat(
                                parseFloat(topUpWalletDetails.add_amount || 0) +
                                  parseFloat(
                                    topUpWalletDetails.wallet_balance || 0
                                  )
                              )
                            }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 border-left-dashed py-2">
                    <div class="mt-5 font-weight-bold fs-16 text-center">
                      <!--  -->
                    </div>
                    <div class="mt-2 font-weight-bold fs-16 text-center">
                      Current Balance {{ Currency | uppercase }}&nbsp;{{
                        currFormat(
                          parseFloat(topUpWalletDetails.add_amount || 0) +
                            parseFloat(topUpWalletDetails.wallet_balance || 0)
                        )
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="d-none" ref="print_wallet_receipt">
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { authenticationService } from "@/services/AuthenticationService";
import Printd from "printd";
import moment from "moment";
import MasterService from "@/services/MasterService";
import PosService from "@/services/PosService";
import { BASEURL } from "@/config/index";

export default {
  components: {},
  data() {
    return {
      EjsData: null,
    };
  },
  props: {
    onClickHandler: {
      type: Function,
    },
    onClickCloseButton: {
      type: Function,
    },
    Currency: {
      type: String,
      default: "",
    },
  },
  computed: {
    topUpWalletDetails() {
      return this.$store.getters.getWalletTopUpDetails;
    },
  },
  beforeMount() {
    this.currentDate = moment().format("DD.MM.YY HH:mm");
    const { cinema_id } = this.secureStore.get("USINFO");
  },
  methods: {
    callClose: function () {
      try {
        if (this.$socket) {
          this.$socket.emit("home_page");
        }
      } catch (err) {}
      this.onClickCloseButton();
    },
  },
};
</script>

<style>
.pos-fnb-final-ticket-wrapper {
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  position: fixed;
  height: calc(100vh - 75px);
  background-color: #fff;
}

.pos-fnb-final-ticket-wrapper .btn-modal-close {
  top: -12px;
  right: 15px;
  position: absolute;
}

.fnb-movie-ticket {
  border-radius: 5px;
  box-shadow: 1px 1px 3px 1px #808080ad;
}

.fnb-movie-table {
  width: 100%;
}

.fnb-mt-cut::before,
.fnb-mt-cut::after {
  content: "";
  width: 25px;
  right: -13px;
  z-index: 22;
  height: 25px;
  display: block;
  border-radius: 50%;
  position: absolute;
  background-color: #fff;
}

.fnb-mt-cut::before {
  top: -13px;
  border-bottom: 2px solid grey;
}

.fnb-mt-cut::after {
  bottom: -13px;
  border-top: 2px solid grey;
}

.fnb-movie-table td:nth-child(2) {
  width: 60px;
  text-align: right;
}
.vh-100 {
  height: 100vh !important;
}
td {
  padding: 0px;
}
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/eWalletRechargeFinalPage.vue